const elementClosest = require('element-closest');

class LayoutHelper {
    static get windowSize() {
        const w = window;
        const d = document;
        const e = d.documentElement;
        const g = d.getElementsByTagName('body')[0];
        const width = w.innerWidth || e.clientWidth || g.clientWidth;
        const height = w.innerHeight || e.clientHeight || g.clientHeight;
        return { width, height };
    }

    static unlockScroll(selector = 'body') {
        const el = document.querySelector(selector);
        el.classList.remove('lock');
    }

    static lockScroll(selector = 'body') {
        const el = document.querySelector(selector);
        el.classList.add('lock');
    }

    static directOrClosest(target, current) {
        elementClosest(window);
        return target === current || target.closest(current);
    }

    static calculateVH() {
        const fn = () => {
            const vh = window.innerHeight * 0.01;
            document.documentElement.style.setProperty('--vh', `${vh}px`);
        };
        window.addEventListener('resize', fn);
        fn();
    }
}
export default LayoutHelper;
